import 'babel-polyfill';
import { initializeIcons } from '@uifabric/icons';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import { GETTING_STARTED, WELCOME } from './actions/page';
import { getApiKey, hasApiKey, hasWelcome } from './services/localStorage';
import { initialState as initialBrandfolderState } from './reducers/brandfolder';
import { initialState as initialPageState } from './reducers/page';
import configureStore from './store/configureStore';

import './index.css';

// intialize Office
let Office;
if (window.Office !== undefined) {
  Office = window.Office;
  initializeIcons();
}

// set initial state
let initialState = {
  brandfolder: {
    ...initialBrandfolderState,
    apiKey: getApiKey() || ''
  },
  page: initialPageState
};

// show getting started if there is no API key in local storage
if (hasWelcome() && !hasApiKey()) {
  initialState = {
    ...initialState,
    page: {
      ...initialPageState,
      page: GETTING_STARTED
    }
  };
}

// show welcome
if (!hasWelcome()) {
  initialState = {
    ...initialState,
    page: {
      ...initialPageState,
      page: WELCOME
    }
  };
}

// configure the store
const store = configureStore(initialState);

const render = () =>
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById('root')
  );

Office.initialize = () => {
  render();
};

Office.initialize();



// WEBPACK FOOTER //
// ./src/index.js